import React from "react";
import Nav from "../components/Nav";
import LiveGames from "../components/LiveGames";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <>
      <Nav />
      <main>
        <LiveGames />
      </main>
      <Footer />
    </>
  );
}
